import { TReduxActions } from '../../../types/redux';
import { EProsActionTypes } from '../../../actions/newReview';
import { TProsRating } from '../../../types/newReview';
import { ENewReviewForm } from '../../../actions/newReview/newReviewsAction';

export const defaultValue = {
  value: null,
};

export function prosReviewReducer(state: TProsRating = defaultValue, { type, payload }: TReduxActions): TProsRating {
  if (type === EProsActionTypes.Set) {
    return {
      value: payload as string,
    };
  }

  if (type === ENewReviewForm.Clear) {
    return defaultValue;
  }

  return state;
}
